import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import SignIn from '../components/pages/Auth/SignIn'
import ForgotPassword from '../components/pages/Auth/ForgotPassword'
import PasswordReset from '../components/pages/Auth/PasswordReset'
import Dashboard from '../components/pages/Dashboard'
import MyProfile from '../components/pages/MyProfile'
import About from '../components/pages/About/'
import AddAbout from '../components/pages/About/add'
import Seo from '../components/pages/Seo/'
import AddSeo from '../components/pages/Seo/add'
import Admins from '../components/pages/Admins/'
import AddAdmin from '../components/pages/Admins/add'
import User from '../components/pages/User/'
import AddUser from '../components/pages/User/add'
import AddLanguage from '../components/pages/Language/add'
import Language from '../components/pages/Language'
import Support from '../components/pages/Support'
import SupportMessage from '../components/pages/Support/message'
import Order from '../components/pages/Orders/order'
import Orders from '../components/pages/Orders'
import Currency from '../components/pages/Currency'
import AddCurrency from '../components/pages/Currency/add'
import Cookie from '../components/pages/Cookie'
import AddCookie from '../components/pages/Cookie/add'
import Pages from '../components/pages/Pages'
import AddPages from '../components/pages/Pages/add'
import Roles from '../components/pages/Roles'
import AddRoles from '../components/pages/Roles/add'
import Certificate from '../components/pages/Certificate'
import AddCertificate from '../components/pages/Certificate/add'
import Permissions from '../components/pages/Permissions'
import AddPermissions from '../components/pages/Permissions/add'
import Continent from '../components/pages/Area/Continent'
import AddContinent from '../components/pages/Area/Continent/add'
import Country from '../components/pages/Area/Country'
import AddCountry from '../components/pages/Area/Country/add'
import Region from '../components/pages/Area/Region'
import AddRegion from '../components/pages/Area/Region/add'
import City from '../components/pages/Area/City'
import AddCity from '../components/pages/Area/City/add'
import Faq from '../components/pages/Faq'
import AddFaq from '../components/pages/Faq/add'
import Sight from '../components/pages/Area/Sight'
import AddSight from '../components/pages/Area/Sight/add'
import District from '../components/pages/Area/District'
import AddDistrict from '../components/pages/Area/District/add'
import Settings from '../components/pages/Settings'
import Hotel from '../components/pages/Hotels/Hotel'
import AddHotel from '../components/pages/Hotels/Hotel/add'
import CompanyService from '../components/pages/Hotels/CompanyService'
import AddCompanyService from '../components/pages/Hotels/CompanyService/add'
import Room from '../components/pages/Hotels/Room'
import AddRoom from '../components/pages/Hotels/Room/add'
import RoomType from '../components/pages/Hotels/RoomType'
import AddRoomType from '../components/pages/Hotels/RoomType/add'
import Discount from '../components/pages/Hotels/Discount'
import AddDiscount from '../components/pages/Hotels/Discount/add'
import Facility from '../components/pages/Hotels/Facility'
import AddFacility from '../components/pages/Hotels/Facility/add'
import FacilityCategory from '../components/pages/Hotels/FacilityCategory'
import AddFacilityCategory from '../components/pages/Hotels/FacilityCategory/add'
import RoomBase from '../components/pages/Hotels/RoomBase'
import AddRoomBase from '../components/pages/Hotels/RoomBase/add'
import Article from '../components/pages/Article/Article'
import AddArticle from '../components/pages/Article/Article/add'
import Tag from '../components/pages/Article/Tag'
import AddTag from '../components/pages/Article/Tag/add'
import Transaction from '../components/pages/Transaction'
import AddTransaction from '../components/pages/Transaction/add'
import ArticleCategory from '../components/pages/Article/ArticleCategory'
import AddArticleCategory from '../components/pages/Article/ArticleCategory/add'
import CreditCard from '../components/pages/CreditCard'
import AddCreditCard from '../components/pages/CreditCard/add'
import Booking from '../components/pages/Booking'
import AddBooking from '../components/pages/Booking/add'
import PaymentRequisite from '../components/pages/PaymentRequisite'
import AddPaymentRequisite from '../components/pages/PaymentRequisite/add'
import Application from '../components/pages/Application'
import ContactUs from '../components/pages/ContactUs'
import Contacts from '../components/pages/Contacts'
import Covid from '../components/pages/Covid'
import Withdrawal from '../components/pages/Withdrawal'
import AddWithdrawal from '../components/pages/Withdrawal/add'
import ServiceOrder from '../components/pages/ServiceOrder'
import AddServiceOrder from '../components/pages/ServiceOrder/add'

import NotFound from '../components/pages/404'
import AuthLayout from '../components/layouts/AuthLayout'
import IndexLayout from '../components/layouts/IndexLayout'
import middlewarePipeline from './middlewarePipeline'

import guest from './middleware/guest'
import auth from './middleware/auth'
import isAdmin from './middleware/isAdmin'
Vue.use(VueRouter)

const index = new VueRouter({
  routes: [
    {
      path: '/auth',
      component: AuthLayout,
      name: 'auth',
      redirect: '/auth/sign-in',
      meta: {
        middleware: [
          guest
        ]
      },
      children: [
        {
          path: 'sign-in',
          name: 'SignIn',
          component: SignIn,
          meta: {
            middleware: [
              guest
            ]
          }
        },
        {
          path: 'forgot-password',
          name: 'ForgotPassword',
          component: ForgotPassword,
          meta: {
            middleware: [
              guest
            ]
          }
        },
        {
          path: 'password-reset',
          name: 'PasswordReset',
          component: PasswordReset,
          meta: {
            middleware: [
              guest
            ]
          }
        }
      ]
    },
    {
      path: '/',
      component: IndexLayout,
      meta: {
        middleware: [
          auth
        ]
      },
      redirect: '/dashboard',
      children: [
        {
          name: 'Contacts',
          path: '/contacts',
          component: Contacts,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Covid',
          path: '/covid',
          component: Covid,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Application',
          path: '/application',
          component: Application,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'ContactUs',
          path: '/contact-us',
          component: ContactUs,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'Booking',
          path: '/booking',
          component: Booking,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'AddBooking',
          path: '/booking/:id',
          component: AddBooking,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'Transaction',
          path: '/transaction',
          component: Transaction,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'AddTransaction',
          path: '/transaction/:id',
          component: AddTransaction,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'PaymentRequisite',
          path: '/payment-requisite',
          component: PaymentRequisite,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'AddPaymentRequisite',
          path: '/payment-requisite/:id',
          component: AddPaymentRequisite,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'CreditCard',
          path: '/credit-card',
          component: CreditCard,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'AddCreditCard',
          path: '/credit-card/:id',
          component: AddCreditCard,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          name: 'Hotel',
          path: '/hotel',
          component: Hotel,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddHotel',
          path: '/hotel/:id',
          component: AddHotel,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Tag',
          path: '/tag',
          component: Tag,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddTag',
          path: '/tag/:id',
          component: AddTag,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Article',
          path: '/article',
          component: Article,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddArticle',
          path: '/article/:id',
          component: AddArticle,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'ArticleCategory',
          path: '/article-category',
          component: ArticleCategory,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddArticleCategory',
          path: '/article-category/:id',
          component: AddArticleCategory,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'CompanyService',
          path: '/company-service',
          component: CompanyService,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddCompanyService',
          path: '/company-service/:id',
          component: AddCompanyService,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Room',
          path: '/room',
          component: Room,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddRoom',
          path: '/room/:id',
          component: AddRoom,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'RoomType',
          path: '/room-type',
          component: RoomType,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddRoomType',
          path: '/room-type/:id',
          component: AddRoomType,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Discount',
          path: '/discount',
          component: Discount,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddDiscount',
          path: '/discount/:id',
          component: AddDiscount,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Facility',
          path: '/facility',
          component: Facility,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddFacility',
          path: '/facility/:id',
          component: AddFacility,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'FacilityCategory',
          path: '/facility-category',
          component: FacilityCategory,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddFacilityCategory',
          path: '/facility-category/:id',
          component: AddFacilityCategory,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'RoomBase',
          path: '/room-base',
          component: RoomBase,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddRoomBase',
          path: '/room-base/:id',
          component: AddRoomBase,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'Faq',
          path: '/faq',
          component: Faq,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          name: 'AddFaq',
          path: '/faq/:id',
          component: AddFaq,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/settings',
          name: 'settings',
          component: Settings,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/profile',
          name: 'profile',
          component: MyProfile,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/support',
          name: 'Support',
          component: Support,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/support/:id',
          name: 'SupportMessage',
          component: SupportMessage,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/continent',
          name: 'Continent',
          component: Continent,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/continent/:id',
          name: 'AddContinent',
          component: AddContinent,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/country',
          name: 'Country',
          component: Country,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/country/:id',
          name: 'AddCountry',
          component: AddCountry,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/region',
          name: 'Region',
          component: Region,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/region/:id',
          name: 'AddRegion',
          component: AddRegion,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/city',
          name: 'City',
          component: City,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/city/:id',
          name: 'AddCity',
          component: AddCity,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/district',
          name: 'District',
          component: District,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/district/:id',
          name: 'AddDistrict',
          component: AddDistrict,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/sight',
          name: 'Sight',
          component: Sight,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/sight/:id',
          name: 'AddSight',
          component: AddSight,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/orders',
          name: 'Orders',
          component: Orders,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/order/:id',
          name: 'Order',
          component: Order,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/currency',
          name: 'Currency',
          component: Currency,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/currency/:id',
          name: 'AddCurrency',
          component: AddCurrency,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/cookie',
          name: 'Cookie',
          component: Cookie,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/cookie/:id',
          name: 'AddCookie',
          component: AddCookie,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/pages',
          name: 'Pages',
          component: Pages,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/pages/:id',
          name: 'AddPages',
          component: AddPages,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/withdrawal',
          name: 'Withdrawal',
          component: Withdrawal,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/withdrawal/:id',
          name: 'AddWithdrawal',
          component: AddWithdrawal,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/certificate',
          name: 'Certificate',
          component: Certificate,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/certificate/:id',
          name: 'AddCertificate',
          component: AddCertificate,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/permissions',
          name: 'Permissions',
          component: Permissions,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/permissions/:id',
          name: 'AddPermissions',
          component: AddPermissions,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/roles',
          name: 'Roles',
          component: Roles,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/roles/:id',
          name: 'AddRoles',
          component: AddRoles,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/language',
          name: 'Language',
          component: Language,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/language/:id',
          name: 'AddLanguage',
          component: AddLanguage,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/service-order',
          name: 'ServiceOrder',
          component: ServiceOrder,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/service-order/:id',
          name: 'AddServiceOrder',
          component: AddServiceOrder,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/seo',
          name: 'Seo',
          component: Seo,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/seo/:id',
          name: 'AddSeo',
          component: AddSeo,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/about',
          name: 'About',
          component: About,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/about/:id',
          name: 'AddAbout',
          component: AddAbout,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/admins',
          name: 'Admins',
          component: Admins,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/admin/:id',
          name: 'AddAdmin',
          component: AddAdmin,
          meta: {
            middleware: [
              auth, isAdmin
            ]
          }
        },
        {
          path: '/user',
          name: 'User',
          component: User,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/user/:id',
          name: 'AddUser',
          component: AddUser,
          meta: {
            middleware: [
              auth
            ]
          }
        },
        {
          path: '/user/:id/login',
          name: 'UserLogin',
          component: AddUser
        },
        {
          path: '/contacts',
          name: 'contacts',
          component: Contacts,
          meta: {
            middleware: [
              auth
            ]
          }
        }
      ]
    },
    {
      path: '*',
      component: NotFound,
      name: 'not-found'
    }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  linkActiveClass: 'active'
})

index.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    store
  }
  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default index
